import React, { useEffect, useState } from "react";
import Select from "react-select";
import { APIClient } from "../../helpers/api_helper";

export const SelectInputCivilState = ({ validation, setValue = () => {} }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const api = new APIClient();

  const getOptions = async () => {
    setLoading(true);
    const response = await api.get("/register/marital-status");
    const result = await response;
    setOptions(
      await result.map((item) => ({
        label: item.name,
        value: item.id,
      }))
    );
    setLoading(false);
  };

  useEffect(() => {
    getOptions();
  }, []);

  return (
    <Select
      noOptionsMessage={() => "Sem resultado!"}
      placeholder="Selecione um estado civil"
      value={validation.values.stateCivilInput}
      loadingMessage={() => "Carregando..."}
      isLoading={loading}
      onChange={(e) => {
        const event = {
          target: {
            name: "stateCivilInput",
            value: e,
          },
        };
        setValue(e);
        validation.handleChange(event);
      }}
      onBlur={validation.handleBlur}
      options={options}
      inputId="stateCivilInput"
    />
  );
};
